import { useSelector } from 'app-redux'
import { SessionMode } from './model/session-mode'
import { selectSessionMode } from './redux'

/**
 * `undefined` while the room's features are still on their way. Callers show
 * a spinner rather than guessing - guessing means rendering the wrong shell.
 */
export const useSessionMode = (): SessionMode | undefined =>
	useSelector(selectSessionMode)
